"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      applyStatusOptions: [{
        label: '全部',
        value: ''
      }, {
        label: '待处理',
        value: 'PENDING',
        tag: 'cyan'
      }, {
        label: '通过审核',
        value: 'APPROVED',
        tag: 'green'
      }, {
        label: '已拒绝',
        value: 'REJECTED',
        tag: 'red'
      }],
      paymentTypeOptions: [{
        label: '微信',
        value: 'WECHAT',
        tag: 'green'
      }, {
        label: '支付宝',
        value: 'ALIPAY',
        tag: 'blue'
      }],
      channelVersionOptions: [{
        label: '小程序',
        value: 'routine',
        tag: 'cyan'
      }, {
        label: 'H5',
        value: 'h5',
        tag: 'blue'
      }],
      transferStatusOptions: [{
        label: '受理成功',
        value: 'ACCEPTED'
      }, {
        label: '处理中',
        value: 'PROCESSING'
      }, {
        label: '待用户收款确认',
        value: 'WAIT_USER_CONFIRM'
      }, {
        label: '转账中',
        value: 'TRANSFERING'
      }, {
        label: '转账成功',
        value: 'SUCCESS'
      }, {
        label: '转账失败',
        value: 'FAIL'
      }, {
        label: '撤销中',
        value: 'CANCELING'
      }, {
        label: '撤销完成',
        value: 'CANCELLED'
      }],
      multipleSelection: [],
      checkIds: []
    };
  },
  computed: {
    formData: function formData() {
      return [
      // { label: '用户搜索', prop: 'user', type: 'user-select-input' },
      {
        label: '用户ID',
        prop: 'userId',
        defaultValue: '',
        type: 'input'
      }, {
        label: '用户手机',
        prop: 'userPhone',
        defaultValue: '',
        type: 'input'
      }, {
        label: '申请状态',
        prop: 'applyStatus',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.applyStatusOptions
        }
      }, {
        label: '转账状态',
        prop: 'transferStatus',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.transferStatusOptions
        }
      }, {
        label: '创建时间',
        prop: 'createTime',
        defaultValue: [],
        type: 'datetimeRange',
        options: {
          startKey: 'startApplyTime',
          endKey: 'endApplyTime',
          startPlaceholder: '开始时间',
          endPlaceholder: '结束时间'
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "ID",
        width: 230
      }, {
        key: 'user',
        visible: true,
        label: "\u7528\u6237",
        width: 200
      }, {
        key: 'withdrawAmount',
        visible: true,
        label: "\u63D0\u73B0\u91D1\u989D",
        width: 100
      }, {
        key: 'paymentType',
        visible: true,
        label: "\u4EA4\u6613\u65B9\u5F0F",
        width: 100,
        formatter: 'tag'
      }, {
        key: 'applyStatus',
        visible: true,
        label: "\u7533\u8BF7\u72B6\u6001",
        width: 100,
        formatter: 'tag'
      }, {
        key: 'channelVersion',
        visible: true,
        label: "\u6E20\u9053\u7248\u672C",
        width: 100,
        formatter: 'tag'
      }, {
        key: 'transferStatus',
        visible: true,
        label: "\u8F6C\u8D26\u72B6\u6001",
        width: 100,
        formatter: 'text'
      }, {
        key: 'auditComment',
        visible: true,
        label: "\u5907\u6CE8",
        width: 160
      },
      // { key: 'failReason', visible: true, label: `失败原因`, width: 160 },
      {
        key: 'time',
        visible: true,
        label: "\u7533\u8BF7/\u5BA1\u6838",
        width: 190
      }];
    }
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.checkedIds = this.multipleSelection.map(function (item) {
        return item.id;
      });
    },
    getList: function getList(params) {
      return (0, _user.getWithdrawListApi)(params);
    },
    selectable: function selectable(row, index) {
      return row.applyStatus === 'PENDING';
    },
    formatter: function formatter(key, value) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text';
      var defaultValue = type === 'text' ? '-' : '';
      var valueKey = type === 'text' ? 'label' : 'tag';
      if (key === 'paymentType') {
        var target = this.paymentTypeOptions.find(function (item) {
          return item.value === value;
        });
        return target && target[valueKey] || defaultValue;
      }
      if (key === 'applyStatus') {
        var _target = this.applyStatusOptions.find(function (item) {
          return item.value === value;
        });
        return _target && _target[valueKey] || defaultValue;
      }
      if (key === 'channelVersion') {
        var _target2 = this.channelVersionOptions.find(function (item) {
          return item.value === value;
        });
        return _target2 && _target2[valueKey] || defaultValue;
      }
      if (key === 'transferStatus') {
        var _target3 = this.transferStatusOptions.find(function (item) {
          return item.value === value;
        });
        return _target3 && _target3[valueKey] || defaultValue;
      }
      return defaultValue;
    },
    handleApproved: function handleApproved(row) {
      var _this = this;
      this.$modalSure('确认同意？').then(function () {
        var params = {
          withdrawRecordId: row.id,
          auditAction: 'APPROVE'
        };
        _this.loading = true;
        (0, _user.auditWithdrawApi)(params).then(function (res) {
          _this.loading = false;
          _this.$refs.searchPage.refresh();
        }).catch(function (err) {
          _this.loading = false;
        });
      });
    },
    handleReject: function handleReject(row) {
      var _this2 = this;
      this.$modalSure('确认拒绝？').then(function () {
        var params = {
          withdrawRecordId: row.id,
          auditAction: 'REJECT'
        };
        _this2.loading = true;
        (0, _user.auditWithdrawApi)(params).then(function (res) {
          _this2.loading = false;
          _this2.$refs.searchPage.refresh();
        }).catch(function (err) {
          _this2.loading = false;
        });
      });
    },
    handleBatchApproved: function handleBatchApproved() {
      var _this3 = this;
      this.$modalSure('确认同意？').then(function () {
        var params = {
          withdrawRecordId: _this3.checkedIds,
          auditAction: 'APPROVE'
        };
        console.log(params);
        // this.loading = true;
        // auditWithdrawApi(params).then((res) => {
        //   this.loading = false;
        //   this.$refs.searchPage.refresh();
        // }).catch((err) => {
        //   this.loading = false;
        // });
      });
    },
    handleBatchReject: function handleBatchReject() {
      var _this4 = this;
      this.$modalSure('确认拒绝？').then(function () {
        var params = {
          withdrawRecordId: _this4.checkedIds,
          auditAction: 'REJECT'
        };
        console.log(params);
        // this.loading = true;
        // auditWithdrawApi(params).then((res) => {
        //   this.loading = false;
        //   this.$refs.searchPage.refresh();
        // }).catch((err) => {
        //   this.loading = false;
        // });
      });
    },
    handleRemark: function handleRemark(row) {
      var _this5 = this;
      this.$modalPrompt('textarea', '备注', row.auditComment || '', {
        inputValidator: function inputValidator(value) {
          if (value && value.length > 500) {
            return '输入限制500字以内';
          }
          return true;
        }
      }).then(function (auditComment) {
        var params = {
          withdrawRecordId: row.id,
          auditComment: auditComment || ''
        };
        _this5.loading = true;
        (0, _user.updateWithdrawCommentApi)(params).then(function (res) {
          _this5.loading = false;
          _this5.$refs.searchPage.refresh();
        }).catch(function (err) {
          _this5.loading = false;
        });
      });
    }
  }
};